"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = require("react");

var _reactIntl = require("react-intl");

var _MessageContext = _interopRequireDefault(require("./MessageContext"));

var dotterize = function dotterize(str1, str2) {
  if (str1 && str2) {
    return str1 + '.' + str2;
  }

  return str1 || str2 || '';
};

var useIntl = function useIntl(_ref) {
  var _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? '' : _ref$scope,
      _ref$ignoreGlobalScop = _ref.ignoreGlobalScope,
      ignoreGlobalScope = _ref$ignoreGlobalScop === void 0 ? false : _ref$ignoreGlobalScop;
  var intl = (0, _reactIntl.useIntl)();

  var _useContext = (0, _react.useContext)(_MessageContext.default),
      globalScope = _useContext.scope;

  var msg = (0, _react.useCallback)(function (_ref2) {
    var id = _ref2.id,
        descriptor = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["id"]);
    var msgScope = ignoreGlobalScope ? scope : dotterize(globalScope, scope);
    var msgId = dotterize(msgScope, id);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    return intl.formatMessage.apply(intl, [(0, _extends2.default)({
      id: msgId
    }, descriptor)].concat(rest));
  }, [globalScope, intl, scope, ignoreGlobalScope]);
  return (0, _extends2.default)({}, intl, {
    msg: msg
  });
};

var _default = useIntl;
exports.default = _default;